import { GUEST_LOGIN, GUEST_LOGOUT, GUEST_SUGGEST_ACCOUNT } from "../Constants/guestconstants";

export const guestReducer = (state = {}, action) => {
  switch (action.type) {
    case GUEST_LOGIN:
      return { isGuest: true, email: action.payload };
    case GUEST_LOGOUT:
      return {};
    case GUEST_SUGGEST_ACCOUNT:
      return { ...state, suggestAccountEmail: action.payload };
    default:
      return state;
  }
};